module.exports = __webpack_public_path__ + "static/logo_ec3d-0c9481be540347addc79da833beee85a.jpg";